import { getSemanticURL } from '../../router/app-router';
import { getResolvedTargetName } from '../../router/routing-manager';
import { ACTION_OPENWORKBYHANDLE } from '../../store/state/actions';
import * as actions from '../../store/state/actions/action-creators';
import { getDataContextName } from '../../container/container-utils';
import { processViewResponse } from '../../store/state/epics/util';
import { getCaseClassName, getCaseInfoID, getContainerName, getDisplayCaseID } from '../common-helper';
import type { Action } from '../../store/state/state-manager';
import type { DxAPIResponseObject } from '../types';

export const handleWorkItemActivation = async (
  actionsOut: Action[],
  options: { activateContainerActionPayload: any; actionInPayload: any }
) => {
  const {
    activateContainerActionPayload: { semanticURL, containerItemID },
    actionInPayload,
    actionInPayload: { context: actionInContext, skipBrowserSemanticUrlUpdate, doDeleteCaseSummary }
  } = options;

  const containerName = getContainerName(ACTION_OPENWORKBYHANDLE, actionInPayload);
  const target = getResolvedTargetName(containerName, actionInContext);
  const context = getDataContextName(containerItemID);

  await processViewResponse(
    {
      directUrlUpdation: !skipBrowserSemanticUrlUpdate,
      semanticURL
    },
    actionInPayload,
    {
      acName:
        target /* [TODO]: we shouldn't use "acName" anywhere, setting this value..since app-router uses this logic */,
      containerName,
      target,
      context
    }
  );

  actionsOut.push(
    actions.postProcess(actions.activateContainerItem, {
      containerItemID,
      target,
      context,
      doDeleteCaseSummary
    })
  );
};

export const getOpenWorkByHandleSemanticURL = (
  dxApiResponse: DxAPIResponseObject,
  actionInPayload: Action['payload']
) => {
  const { isRemoteCase, remoteCaseClass } = actionInPayload;
  const caseInfoID = getCaseInfoID(dxApiResponse);
  const caseClassName = isRemoteCase ? remoteCaseClass : getCaseClassName(dxApiResponse);
  const queryParameters = { id: actionInPayload?.insKey };
  let semanticURL = getSemanticURL(ACTION_OPENWORKBYHANDLE, { caseClassName }, queryParameters);
  semanticURL = semanticURL
    ?.replace('{workID}', String(getDisplayCaseID(caseInfoID)))
    ?.replace('{id}', actionInPayload?.insKey);
  return semanticURL;
};
